module.exports = __webpack_public_path__ + "img/1.127a98b8.png";